import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../Layouts/context/Authcontext';
import api from '../../../../api';
import LeakageDonutChart from '../TeamLeaderDashboard/LeakageDonutChart';
import LeakageTableCard from '../../../../Data/DashboardData/TeamLeadDBData/LeakageTableCard.json';
import AMDMErrorSubCatData from '../../../../Data/DashboardData/AMDMData/AMDMErrorSubCatData.json';
import EmployeeLeakage from '../../../../Data/DashboardData/TeamLeadDBData/EmployeeLeakage.json';
import EfficiencyLeakage from '../../../../Data/DashboardData/TeamLeadDBData/EfficiencyLeakage.json';
import TopLeakageUsers from '../TeamLeaderDashboard/TopLeakageUsers';
import TopEfficiencyUsers from '../TeamLeaderDashboard/TopEfficiencyUsers';
import CardCompLeakage from '../TeamLeaderDashboard/CardCompLeakage';
import CardCompTableLeakage from '../TeamLeaderDashboard/CardCompTableLeakage';
import LeakageSummaryCard from '../TeamLeaderDashboard/LeakageSummaryCard';
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';

function AMDMLeakageTab() {
  const [summaryData, setSummaryData] = useState(null);
  const [isDefaultMTD, setIsDefaultMTD] = useState(true);
  const { accessToken } = useAuth();
  const [childQueryParams, setChildQueryParams] = useState({});

  // Callback to receive parameters from CardCompTableLeakage
  const handleParamsChange = (params) => {
    setChildQueryParams(params);
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const getMTDDates = () => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      formattedMtdStartDate: formatDate(startOfMonth),
      formattedMtdEndDate: formatDate(today),
    };
  };

  useEffect(() => {
    const { formattedMtdStartDate, formattedMtdEndDate } = getMTDDates();
    const fetchSummaryData = async () => {
      try {
        let baseUrls= getRoundRobinBaseUrl();
        let urlParams = Object.keys(childQueryParams).length > 0
          ? childQueryParams
          : {
              startDate: formattedMtdStartDate,
              endDate: formattedMtdEndDate,
            };
        const response = await api.get(
          `${baseUrls}/managerDashboard/getCustomDateLeakage`,
          {
            params: urlParams,
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        if (response.data && response.data.data) {
          setSummaryData(response.data.data);
          setIsDefaultMTD(true);
        }
      } catch (error) {
        // console.error('Error fetching summary data:', error);
      }
    };

    fetchSummaryData();
  }, [accessToken, childQueryParams]);

  return (
    <div className="p-4 animate-fade-in space-y-6">
      {/* Row 1: Animated Leakage Cards */}
      <div>
        <CardCompLeakage />
      </div>

      {/* Row 2: Leakage Summary */}
      <div className="bg-white shadow-2xl rounded-xl p-4 transition-transform hover:scale-105">
        <LeakageSummaryCard summaryData={summaryData} />
      </div>

      {/* Row 3: Leakage Table */}
      <div className="bg-white shadow-2xl rounded-xl p-4">
        <CardCompTableLeakage onParamsChange={handleParamsChange} />
      </div>

      {/* Row 4: Top 5 Charts */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white shadow-2xl rounded-xl p-4 transition-transform hover:scale-105">
          <TopLeakageUsers />
        </div>
        <div className="bg-white shadow-2xl rounded-xl p-4 transition-transform hover:scale-105">
          <TopEfficiencyUsers />
        </div>
      </div>
    </div>
  );
}

export default AMDMLeakageTab;
